<div class="datepicker-container" [ngClass]="rootClassName">
  <div class="datepicker-week">
    @for (element of elements; track $index) {
      <button class="datepicker-buttondatepicker" [ngClass]="{'active':isActive(element)}" (click)="onSelect(element)">
        <span class="datepicker-text headingboldlarge">
          <span>{{getDayNumber(element.date)}}</span>
        </span>
        <span class="datepicker-text labelregularsmall">
          <span>{{getDayName(element.date)}}</span>
        </span>
      </button>
    }
  </div>
  <div class="frame32pxspacer"></div>
</div>
